/**
 * CurrencySwitcher.jsx — Tiny pill-shaped dropdown that switches the
 * platform-wide currency rendering. Persists to localStorage; emits a
 * `granullo-locale-change` event so all useLocale() consumers re-render.
 */
import React from 'react';
import { useLocale } from '../../utils/locale';

const ACCENT = {
  USD: '#10B981',
  EUR: '#2563EB',
  GBP: '#7c3aed',
  AED: '#CD2200',
  INR: '#D97706',
  SGD: '#0E7A4F',
};

export default function CurrencySwitcher({ compact = false }) {
  const { currency, currencies, setCurrency } = useLocale();
  const accent = ACCENT[currency] || 'var(--shell-text)';

  return (
    <label
      className="inline-flex items-center gap-1.5 px-2 py-1 rounded text-[10.5px] font-mono uppercase tracking-[0.14em]"
      style={{
        border: '1px solid var(--shell-border)',
        background: 'var(--shell-surface)',
        color: 'var(--shell-text-muted)',
        cursor: 'pointer',
      }}
      data-testid="currency-switcher"
      title="Switch display currency"
    >
      {!compact && <span>Display</span>}
      <select
        value={currency}
        onChange={(e) => setCurrency(e.target.value)}
        className="bg-transparent outline-none border-0 cursor-pointer font-semibold"
        style={{ color: accent }}
        data-testid="currency-switcher-select"
      >
        {currencies.map((c) => (
          <option key={c} value={c} style={{ color: 'var(--shell-text)' }}>{c}</option>
        ))}
      </select>
    </label>
  );
}
